// @flow
export { BankIntro } from './BankIntro';
